<template>
  <b-form-group
    label="Kullanıcı Yetkisi"
    label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      name="Kullanıcı Yetkisi"
      rules="required"
    >
      <v-select
        id="id_user_types"
        v-model="dataItem.id_user_types"
        :options="userTypes"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  name: 'UserTypes',
  components: {
    ValidationProvider,
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['drUsers/dataItem']
    },
    userTypes() {
      return this.$store.getters['drUserTypes/dataList']
    },
  },
  created() {
    this.getUserTypes()
  },
  methods: {
    getUserTypes() {
      this.$store.dispatch('drUserTypes/getDataList', {
        where: {
          'user_types.id_licenses': this.$route.params.id,
        },
      })
    },
  },
}
</script>
